
// @ts-nocheck


export const localeCodes =  [
  "en"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_45base_46json_b0c430b0",
      load: () => import("#nuxt-i18n/b0c430b0" /* webpackChunkName: "locale_en_45base_46json_b0c430b0" */),
      cache: true
    },
    {
      key: "locale_en_46json_f1cb9621",
      load: () => import("#nuxt-i18n/f1cb9621" /* webpackChunkName: "locale_en_46json_f1cb9621" */),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      iso: "en-US",
      files: [
        {
          path: "/codebuild/output/src489166772/src/cb-admin/node_modules/.c12/github_LiminalFlow_app_kPdycbsmy/i18n/locales/en-base.json",
          cache: undefined
        },
        {
          path: "/codebuild/output/src489166772/src/cb-admin/i18n/locales/en.json",
          cache: undefined
        }
      ],
      name: "English"
    }
  ],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: true,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    iso: "en-US",
    files: [
      {
        path: "/codebuild/output/src489166772/src/cb-admin/node_modules/.c12/github_LiminalFlow_app_kPdycbsmy/i18n/locales/en-base.json",
        cache: undefined
      },
      {
        path: "/codebuild/output/src489166772/src/cb-admin/i18n/locales/en.json",
        cache: undefined
      }
    ],
    name: "English"
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/